<template>
    <div v-if="model">
        <div v-if="totalizadores">
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :value="totalizadores.totalPacientesAgendados"
                        disabled
                        label="Total de pacientes agendados"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="totalizadores.totalFaltasNoDia"
                        disabled
                        label="Total de faltas no dia"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="totalizadores.totalPacientesAtendidosNoDia"
                        disabled
                        label="Total de pacientes atendidos no dia"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :value="totalizadores.totalPacientesEmAtendimento"
                        disabled
                        label="Total de pacientes em atendimento"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="totalizadores.totalPacientesAguardandoAtendimento"
                        disabled
                        label="Total de pacientes aguardando atendimento"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :value="totalizadores.totalEvasoes"
                        disabled
                        label="Total de evasões"
                    />
                </rkm-col>
            </rkm-row>
        </div>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-table
                    :busy="busy"
                    :fields="fields"
                    :filter="filter"
                    :items="filteredItems"
                    ref="RkmTable"
                >
                    <template v-slot:filters>
                        <rkm-row>
                            <rkm-col cols="9">
                                <rkm-form-input
                                    label="Buscar"
                                    placeholder="Digite para buscar"
                                    v-model="filter"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.temposEspera"
                                    default-option-text="Todos"
                                    label="Tempo de espera"
                                    show-default-option
                                    text-field="minutos"
                                    v-model="model.tempoEsperaId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.opcoesEntrada"
                                    default-option-text="Todas"
                                    label="Opção de entrada"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.opcaoEntradaId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.prioridades"
                                    default-option-text="Todas"
                                    label="Prioridade"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.prioridadeId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.status"
                                    default-option-text="Todos"
                                    label="Status"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.statusId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.ordenacoes"
                                    label="Ordenação"
                                    v-model="model.ordenacao"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:cell(tempoEspera)="{item}">
                        <rkm-icon
                            v-if="item.tempoEspera.id"
                            :id="uniqueId('tempo-espera-tooltip')"
                            :style="'color: ' + item.tempoEspera.cor"
                            :title="formatTempoEspera(item.tempoEspera.total)"
                            font-scale="2"
                            icon="battery-full"
                            v-rkm-tooltip.hover
                        />

                        <span v-else>
                            -
                        </span>
                    </template>

                    <template v-slot:cell(actions)="{item}">
                        <template v-if="form.telas.length > 0">
                            <rkm-dropdown
                                v-if="form.telas.length > 1"
                                :color="item.chamadas > 0 ? 'secondary' : 'info'"
                                class="mr-2"
                                small
                                title="Chamar"
                                v-rkm-tooltip.hover
                            >
                                <template v-slot:button-content>
                                    <rkm-icon icon="volume-up" />

                                    <rkm-badge v-if="item.chamadas > 0">
                                        {{ item.chamadas }}
                                    </rkm-badge>
                                </template>

                                <rkm-dropdown-item
                                    v-for="tela in form.telas"
                                    @click="call(item.id, tela.id)"
                                    v-bind:key="tela.id"
                                >
                                    {{tela.nome}}
                                </rkm-dropdown-item>
                            </rkm-dropdown>

                            <rkm-button
                                v-else
                                :color="item.chamadas > 0 ? 'secondary' : 'info'"
                                @click="call(item.id, form.telas[0].id)"
                                small
                                title="Chamar"
                            >
                                <rkm-icon icon="volume-up" />

                                <rkm-badge v-if="item.chamadas > 0">
                                    {{item.chamadas}}
                                </rkm-badge>
                            </rkm-button>
                        </template>

                        <rkm-button
                            @click="create(item.id)"
                            color="primary"
                            small
                            title="Atender"
                        >
                            <rkm-icon icon="plus" />
                        </rkm-button>

                        <rkm-button
                            @click="destroy(item.id)"
                            color="danger"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>

        <ModalChamada
            :salas="form.salas"
            ref="ModalChamada"
        />
    </div>
</template>

<script>
// Components.
import ModalChamada from '@/components/ambulatorio/components/chamada/Modal'

// Enums.
import modulo from '@/enums/administracao/modulo'
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {ModalChamada},
    computed: {
        ...mapGetters({
            centroCusto: 'getCentroCusto',
            customer: 'getCustomer',
            lotacao: 'getLotacao',
        }),
        filteredItems() {
            let fila = this.model.fila

            if (this.model.tempoEsperaId) {
                fila = fila.filter(item => item.tempoEspera.id === this.model.tempoEsperaId)
            }

            if (this.model.opcaoEntradaId) {
                fila = fila.filter(item => item.opcaoEntradaId === this.model.opcaoEntradaId)
            }

            if (this.model.prioridadeId) {
                fila = fila.filter(item => item.prioridadeId === this.model.prioridadeId)
            }

            if (this.model.statusId) {
                fila = fila.filter(item => item.statusId === this.model.statusId)
            }

            return fila.sort((a, b) => {

                let sort = this.sortNumber(a.classificacaoRiscoId, b.classificacaoRiscoId, false)
                    || this.sortNumber(a.prioridadeGrau, b.prioridadeGrau, false)

                if (this.model.ordenacao === 'dataHoraAgendamento') {

                    sort = sort || this.sortString(a.dataHoraAgendamento, b.dataHoraAgendamento)
                }
                else if (this.model.ordenacao === 'dataHoraChegada') {

                    sort = sort || this.sortString(a.dataHoraChegada, b.dataHoraChegada)
                }

                return sort || this.sortNumber(a.numeroSenha, b.numeroSenha)
            })
        },
    },
    created() {
        this.repositories = {
            chamada: this.getConectaSusRepository('ambulatorio.chamada'),
            fila: this.getConectaSusRepository('ambulatorio.fila'),
            recepcao: this.getConectaSusRepository('ambulatorio.recepcao'),
        }
    },
    data: () => ({
        busy: false,
        enums: {
            modulo,
            setorTipo,
        },
        fields: [
            {key: 'tempoEspera', label: 'Tempo de espera'},
            {key: 'opcaoEntradaNome', label: 'Opção de entrada'},
            {key: 'senha', label: 'Senha'},
            {key: 'prioridadeNome', label: 'Prioridade'},
            {key: 'horarioChegada', label: 'Horário de chegada'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações', name: 'actions'},
        ],
        filter: null,
        form: null,
        model: null,
        totalizadores: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortString(a, b, ascending = true) {

            return this.sortNullsLast(a, b, () => ascending ? a.localeCompare(b) : b.localeCompare(a))
        },
        sortNumber(a, b, ascending = true) {

            return this.sortNullsLast(a, b, () => ascending ? a - b : b - a)
        },
        sortNullsLast(a, b, sort) {

            if (a === b) {

                return 0
            }
            else if (a === null) {

                return 1
            }
            else if (b === null) {

                return -1
            }
            else {

                return sort()
            }
        },
        init() {
            this.pusher.subscribe(`private-${this.customer.link}-painel-senha-fila`)
                .bind(`${this.centroCusto.setor.tipoId}.${this.centroCusto.id}.${this.enums.modulo.AMBULATORIO}.updated`, (data) => {
                    this.model.fila = Object.assign(this.snakeObjectKeysToCamelRecursive(data.fila))
                })
        },
        load() {
            this.setLoading()

            const request = {
                centroCustoId: this.centroCusto.id,
                setorTipoId: this.enums.setorTipo.RECEPCAO,
            }

            this.repositories.fila.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadTotalizadores() {
            this.setLoading()

            this.repositories.recepcao.list({listar: 'totalizadores'})
                .then(response => this.totalizadores = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        call(filaId, telaId) {
            const request = {
                filaId: filaId,
                telaId: telaId,
            }

            if (this.form.salas.length > 0) {
                this.$refs.ModalChamada.open(filaId, telaId)
            } else {
                this.busy = true

                this.repositories.chamada.store(this.camelObjectKeysToSnakeRecursive(request))
                    .catch(this.handleError)
                    .finally(() => this.busy = false)
            }
        },
        create(filaId) {
            this.$router.push({name: 'ambulatorio-recepcao-create', params: {filaId}})
        },
        destroy(filaId) {
            const destroy = () => this.repositories.fila.destroy(filaId)

            this.showDeleteConfirmation('Deseja realmente excluir a senha?', destroy)
        },
        formatTempoEspera(value) {
            let format = 'Esperando por'

            if (value.dias !== null) {
                format = `${format} ${value.dias} dia(s)`
            }

            if (value.horas !== null) {
                format = `${format} ${value.horas} hora(s)`
            }

            if (value.minutos !== null) {
                if (value.horas !== null) {
                    format = `${format} e ${value.minutos} minuto(s)`
                } else {
                    format = `${format} ${value.minutos} minuto(s)`
                }
            }

            return format
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.init()

        Promise.all([
            this.load(),
            this.loadTotalizadores(),
        ])
    },
}
</script>